/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TableRow,
  TextField,
} from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import confetti from 'canvas-confetti';
import axios from 'axios';
import { storeContext } from '../provider/Provider';
import GreenButton from '../../customUI/GreenButton';
import RedButton from '../../customUI/RedButton';
import { leadsActions } from '../../store/leads-reducer';
import { StyledTableCell } from '../../customUI/table/TableStyles';

const { REACT_APP_FLASK_API_URL } = process.env;

const useStyles = makeStyles(() => ({
  blackLink: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
  },
  squareButton: {
    borderRadius: 4,
  },
  arrowButton: {
    padding: 0,
    marginLeft: 0,
    marginRight: 6,
  },
}));

const LeadsTableRow = ({ row }) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const [settingStatus, setSettingStatus] = React.useState('won');
  const [email, setEmail] = React.useState(row.leadBody.email);
  const [fullName, setFullName] = React.useState(row.leadBody.fullName);
  const [phone, setPhone] = React.useState(row.leadBody.phone);
  const { dispatch } = React.useContext(storeContext);

  const handleStatusBtnClick = (newStatus) => {
    setSettingStatus(newStatus);
    setOpenDialog(true);
  };

  const handleSubmitStatusChange = () => {
    const data = { lead_uuid: row.uuid, status: settingStatus };
    if (email !== row.leadBody.email) {
      data.email = email;
    }
    if (fullName !== row.leadBody.fullName) {
      data.fullName = fullName;
    }
    if (phone !== row.leadBody.phone) {
      data.phone = phone;
    }
    axios.post(`${REACT_APP_FLASK_API_URL}/v1/leads/update`, data).then(() => {
      setOpenDialog(false);
    });
    if (settingStatus === 'won') {
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
    }
    dispatch({
      type: leadsActions.LEADS_UPDATE_LEAD,
      payload: {
        ...row,
        status: settingStatus,
        leadBody: {
          ...row.leadBody,
          email,
          fullName,
          phone,
        },
      },
    });
  };
  return (
    <>
      <TableRow key={row.leadBody.email}>
        <StyledTableCell component="th" scope="row" style={{ whiteSpace: 'nowrap'}}>
          {`${new Date(row.createdAt).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })}`}
        </StyledTableCell>
        <StyledTableCell>
          <IconButton
            aria-label="expand row"
            className={classes.arrowButton}
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open ? (
              <KeyboardArrowUpIcon style={{ fontSize: 'medium' }} />
            ) : (
              <KeyboardArrowDownIcon style={{ fontSize: 'medium' }} />
            )}
          </IconButton>
          {row.leadBody.fullName}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {row.leadBody.chat ? <span>Chat</span> : <span>Form</span>}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row" />
        <StyledTableCell component="th" scope="row">
          <a className={classes.blackLink} href={`mailto:${row.leadBody.email}`}>
            {row.leadBody.email}
          </a>
        </StyledTableCell>
        <StyledTableCell style={{textAlign: 'center'}}>
          {!row.leadBody.chat && (
            <IconButton
              aria-label="expand row chat"
              className={classes.arrowButton}
              onClick={() => setOpen(!open)}
            >
              <ChatIcon style={{ fontSize: 'large' }} />
            </IconButton>
          )}
        </StyledTableCell>
        <StyledTableCell>
          {row.leadBody.chat && (
            <IconButton
              aria-label="expand row chat"
              className={classes.arrowButton}
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <KeyboardArrowUpIcon style={{ fontSize: 'medium' }} />
              ) : (
                <KeyboardArrowDownIcon style={{ fontSize: 'medium' }} />
              )}
            </IconButton>
          )}
        </StyledTableCell>
        <StyledTableCell style={{ minWidth: 150 }} align="center">
          {row.status === 'won' ? (
            <GreenButton className={classes.squareButton} disabled>
              Won
            </GreenButton>
          ) : (
            <GreenButton
              className={classes.squareButton}
              aria-label="change status to won"
              onClick={() => {
                handleStatusBtnClick('won');
              }}
            >
              Won
            </GreenButton>
          )}
          {row.status === 'lost' ? (
            <RedButton className={classes.squareButton} disabled>
              Lost
            </RedButton>
          ) : (
            <RedButton
              className={classes.squareButton}
              aria-label="change status to lost"
              onClick={() => {
                handleStatusBtnClick('lost');
              }}
            >
              Lost
            </RedButton>
          )}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {Object.entries(row.leadBody).map(([key, value]) => {
              if (typeof value !== 'object') {
                return (
                  <React.Fragment key={row.uuid + value}>
                    <strong>{key}: </strong>
                    <span>{value}</span>
                    <br />
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </Collapse>
        </StyledTableCell>
      </TableRow>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        {settingStatus === 'won' ? (
          <DialogTitle id="form-dialog-title">Lead Signed</DialogTitle>
        ) : (
          <DialogTitle id="form-dialog-title">Rejected</DialogTitle>
        )}

        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email Address"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="full name"
            label="Full Name"
            fullWidth
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="phone"
            label="Phone"
            fullWidth
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
            }}
            style={{ color: '#58595B' }}
          >
            Cancel
          </Button>
          {settingStatus === 'won' ? (
            <GreenButton aria-label="submit won" onClick={handleSubmitStatusChange}>
              Submit
            </GreenButton>
          ) : (
            <RedButton aria-label="submit lost" onClick={handleSubmitStatusChange}>
              Submit
            </RedButton>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LeadsTableRow;
